import { NAME_IN_LEGEND_DEFAULT, PARTNER_OPTION_DEFAULT } from 'ChartApp/ts/apps/scatter-plot/constants';
import { ScatterPlotChartOptionValue, ScatterPlotChartType, ScatterPlotPlotOptionValue, ScatterPlotPlotType, ScatterPlotPresentationOptionValue, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { formatDateString, getOneYearAgo } from 'Core/redesign/utils/date';
export const DATA_FORMAT_DEFAULT_STATE = {
    aggregation: 'last',
    fillMethod: 'no_fill',
    frequency: '',
};
export const SCATTER_PLOT_APP_STATE_SLICE_KEY = 'scatterPlot';
export const SCATTER_PLOT_SYSTEM_DEFAULT_STATE = {
    chartId: null,
    chartType: ScatterPlotChartType.interactive,
    axisExtremes: {},
    // Interactive Chart options
    [ScatterPlotChartOptionValue.displayAllCurrencyCodes]: false,
    [ScatterPlotChartOptionValue.displayAllXYData]: false,
    [ScatterPlotChartOptionValue.displayAllDates]: false,
    [ScatterPlotChartOptionValue.displayAllNames]: false,
    [ScatterPlotChartOptionValue.displayAllTickers]: false,
    [ScatterPlotChartOptionValue.displayBestFitLine]: false,
    [ScatterPlotChartOptionValue.displayLegend]: true,
    [ScatterPlotChartOptionValue.displayCurrencyCodeInLegend]: false,
    [ScatterPlotChartOptionValue.displayXYDataInLegend]: true,
    [ScatterPlotChartOptionValue.displayColorRange]: false,
    [ScatterPlotChartOptionValue.nameInLegend]: NAME_IN_LEGEND_DEFAULT,
    [ScatterPlotChartOptionValue.useCustomColors]: false,
    // Presentation Chart Options
    [ScatterPlotChartOptionValue.displayLegendOnChart]: false,
    // Presentation Options
    [ScatterPlotChartOptionValue.performanceDisclosure]: false,
    [ScatterPlotPresentationOptionValue.note]: '',
    [ScatterPlotPlotOptionValue.size]: PARTNER_OPTION_DEFAULT,
    [ScatterPlotPresentationOptionValue.title]: '',
    labelPlacements: {},
    plotOptions: {},
    plotType: ScatterPlotPlotType.pointInTime,
    securities: [],
    xAxisMetric: '',
    yAxisMetric: '',
    // Point in Time
    xAxisDate: null,
    yAxisDate: null,
    lookback: null,
    // Timeseries
    dataFormat: DATA_FORMAT_DEFAULT_STATE,
    endDate: formatDateString(new Date()),
    startDate: formatDateString(getOneYearAgo(new Date())),
};
// Only store necessary NgRx store data in the url app state
export const SCATTER_PLOT_STATE_KEYS = Object.keys(SCATTER_PLOT_SYSTEM_DEFAULT_STATE);
// Keys added here should also have default fields added in
// ycharts/apps/charts/services/scatter_plot.py:SCATTER_PLOT_PARAM_DEFAULTS
const SAVED_SCATTER_PLOT_STATE_KEYS = SCATTER_PLOT_STATE_KEYS.slice();
SAVED_SCATTER_PLOT_STATE_KEYS.splice(SCATTER_PLOT_STATE_KEYS.indexOf('chartId'), 1);
export { SAVED_SCATTER_PLOT_STATE_KEYS };
export const SAVED_SCATTER_PLOT_REQUEST_KEYS = SAVED_SCATTER_PLOT_STATE_KEYS.concat('chartName');
export const SAVED_SCATTER_PLOT_TIMESERIES_ADDITIONAL_KEYS = ['dataFormat', 'startDate', 'endDate'];
// Map objects
export const CHART_OPTION_TO_PLOT_OPTION_MAP = {
    [ScatterPlotChartOptionValue.displayAllCurrencyCodes]: 'display_currency_code',
    [ScatterPlotChartOptionValue.displayAllDates]: 'display_dates',
    [ScatterPlotChartOptionValue.displayAllNames]: 'display_name',
    [ScatterPlotChartOptionValue.displayAllTickers]: 'display_ticker',
    [ScatterPlotChartOptionValue.displayAllXYData]: 'display_x_y_data',
};
